import { ChangeDetectionStrategy, Component, DestroyRef, computed, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatButtonModule } from '@angular/material/button';
import { IncomingCallEvent, WebSocketService } from '../../core/services/websocket.service';
import { PermissionService } from '../../core/services/permission.service';
import { PERMISSIONS } from '../../core/constants/permissions.constants';

@Component({
  selector: 'app-incoming-call-banner',
  imports: [MatButtonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './incoming-call-banner.component.html',
  styleUrl: './incoming-call-banner.component.css',
})
export class IncomingCallBannerComponent {
  private readonly ws = inject(WebSocketService);
  private readonly router = inject(Router);
  private readonly permissionService = inject(PermissionService);
  private readonly destroyRef = inject(DestroyRef);
  readonly call = signal<IncomingCallEvent | null>(null);

  readonly peutCreerTicket = computed(() => this.permissionService.hasPermission(PERMISSIONS.TICKET_CREATE));
  readonly peutCreerClient = computed(() => this.permissionService.hasPermission(PERMISSIONS.CLIENT_CREATE));

  constructor() {
    this.ws.incomingCall$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((call) => this.call.set(call));
  }

  dismiss(): void {
    this.ws.clearIncomingCall();
  }

  openTicket(call: IncomingCallEvent): void {
    this.dismiss();
    void this.router.navigate(['/tickets/nouveau'], {
      queryParams: { clientId: call.clientId, canal: 'TELEPHONE', telephone: call.telephone, callId: call.callId },
    });
  }

  createClient(call: IncomingCallEvent): void {
    this.dismiss();
    void this.router.navigate(['/clients/nouveau'], { queryParams: { telephone: call.telephone } });
  }
}
